module.exports = __webpack_public_path__ + "static/media/89.ec8c57f7.jpg";